import { cn } from '../lib/utils';

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  className = '',
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }

    return pages;
  };

  if (totalItems === 0) {
    return null;
  }

  const buttonBase = 'px-3 py-1.5 text-sm rounded-md transition-colors';
  const buttonActive = 'bg-[var(--maroon)] text-white';
  const buttonInactive = 'text-[var(--electric-blue)] hover:bg-gray-100';
  const buttonDisabled = 'text-gray-300 cursor-not-allowed';

  return (
    <div className={cn('flex items-center justify-between py-4 px-4 border-t border-[var(--bright-gray)]', className)}>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={cn(buttonBase, currentPage === 1 ? buttonDisabled : buttonInactive)}
        >
          ← Poprzednia
        </button>

        <div className="flex items-center gap-1">
          {getPageNumbers().map((page, index) => (
            page === '...' ? (
              <span key={`ellipsis-${index}`} className="px-2 text-gray-400">...</span>
            ) : (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={cn(buttonBase, page === currentPage ? buttonActive : buttonInactive)}
              >
                {page}
              </button>
            )
          ))}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={cn(buttonBase, currentPage === totalPages ? buttonDisabled : buttonInactive)}
        >
          Następna →
        </button>
      </div>

      <div className="flex items-center gap-4 text-sm text-[var(--electric-blue)]">
        <span>
          Wyświetlono {startItem}-{endItem} z {totalItems}
        </span>

        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className="px-2 py-1 border border-[#D7D7D7] rounded-md focus:outline-none focus:border-[var(--electric-blue)]"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};

export default Pagination;
